import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Services API
export const getServices = async (params = {}) => {
  try {
    const response = await api.get('/services', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching services:', error);
    throw error;
  }
};

export const getServiceById = async (id) => {
  try {
    const response = await api.get(`/services/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching service:', error);
    throw error;
  }
};

export const createService = async (serviceData) => {
  try {
    const response = await api.post('/services', serviceData);
    return response.data;
  } catch (error) {
    console.error('Error creating service:', error);
    throw error;
  }
};

// Categories API
export const getCategories = async () => {
  try {
    const response = await api.get('/categories');
    return response.data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

// OTP API
export const sendOTP = async (mobileNumber, category) => {
  try {
    const response = await api.post('/otp/send', { mobileNumber, category });
    return response.data;
  } catch (error) {
    console.error('Error sending OTP:', error);
    // Return error response instead of throwing to handle gracefully
    return error.response?.data || { success: false, message: 'Failed to send OTP' };
  }
};

export const verifyOTP = async (mobileNumber, category, code) => {
  try {
    const response = await api.post('/otp/verify', { mobileNumber, category, code });
    return response.data;
  } catch (error) {
    console.error('Error verifying OTP:', error);
    return error.response?.data || { success: false, message: 'Failed to verify OTP' };
  }
};

export const checkOTPStatus = async (mobileNumber, category) => {
  try {
    const response = await api.post('/otp/check-status', { mobileNumber, category });
    return response.data;
  } catch (error) {
    console.error('Error checking OTP status:', error);
    return error.response?.data || { success: false, message: 'Failed to check status' };
  }
};

export default api;

